var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoldedStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 11,
    viewBox: "206.5 16 25 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 2017"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Trac\\xE9 6767"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212 16h14a5.5 5.5 0 1 1 0 11h-14a5.5 5.5 0 1 1 0-11Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 16h14a5.5 5.5 0 1 1 0 11h-14a5.5 5.5 0 1 1 0-11Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#707070",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 2157"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 2016"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 113"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221 21.4a2.5 2.5 0 1 1 0 .1z",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221 21.4a2.5 2.5 0 1 1 0 .1z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#707070",
    fill: "transparent"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 2156"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 113"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211 21.4a2.5 2.5 0 1 1 0 .1z",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 21.4a2.5 2.5 0 1 1 0 .1z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#707070",
    fill: "transparent"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoldedStatus);
export default __webpack_public_path__ + "static/media/soldedStatus.a76a5a6461aca79afb8f99ab7e430e62.svg";
export { ForwardRef as ReactComponent };